import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import { useTranslation } from "react-i18next"

import { Link } from "react-router-dom"
import classnames from "classnames"

import ClubRegister from "./components/ClubRegister"
import AgentRegister from "./components/AgentRegister"

// import images
import logo from "../../assets/images/logo.png"
import LanguageDropdown from "components/CommonForBoth/TopbarDropdown/LanguageDropdown"

export default function Register(props) {
  document.title = "Register | PlayMaker Club"
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState("1")

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab)
  }
  return (
    <React.Fragment>
      <div className="d-flex justify-content-end">
        <div style={{ marginRight: "4%" }}>
          <LanguageDropdown />
        </div>

        <div className="home-btn d-none d-sm-block">
          <Link to="https://playmaker-club.com" className="text-dark">
            <i className="fas fa-home h2" />
          </Link>
        </div>
      </div>

      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={8}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <div className="text-primary text-center p-4">
                    <h5 className="text-white font-size-20">
                      {t("register.createAccount")}{" "}
                    </h5>
                    <p className="text-white-50">
                      {t("register.signUpDescription")}
                    </p>
                    <Link to="/" className="logo logo-admin">
                      <img src={logo} height="55" alt="logo" />
                    </Link>
                  </div>
                </div>

                <CardBody className="p-4">
                  <div className="p-3">
                    {/* <ClubRegister></ClubRegister> */}
                    {/* {<AgentRegister></AgentRegister>} */}
                    <Nav tabs className="mb-4">
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "1" })}
                          onClick={() => toggleTab("1")}
                          role="button"
                        >
                          Club
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "2" })}
                          onClick={() => toggleTab("2")}
                          role="button"
                        >
                          Agent
                        </NavLink>
                      </NavItem>
                    </Nav>

                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="1">
                        <ClubRegister />
                      </TabPane>
                      <TabPane tabId="2">
                        <AgentRegister />
                      </TabPane>
                    </TabContent>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("register.alreadyHaveAccount")}
                  <Link to="/login" className="fw-medium text-primary">
                    {" "}
                    {t("register.signIn")}
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
